module.exports = __webpack_public_path__ + "img/color.10e37cf5.svg";